import { atom } from 'jotai';

export const foldedItemIndexAtom = atom<string[]>([]);
